module.exports = __webpack_public_path__ + "static/media/1013153.5d100cba.png";